import React, { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';
import './button.scss';

type TButton = {
	children?: React.ReactNode;
	onClick?: any;
	gtmClass?: 'primary' | 'secondary'
	type?: 'button' | 'submit' | 'reset';
	className?: string;
	text?: string;
	disabled?: boolean;
	style?: any
}

const Button = ({ children, onClick, gtmClass = "primary", type, className, text, disabled = false, style }: TButton) => {
	return (
		<button
			type={type || 'button'}
			className={`button button--${gtmClass} ${className ? className : ''}`}
			onClick={onClick || (() => { })}
			disabled={disabled}
			style={style}
		>
			{text || children}
		</button>
	)
}

export default Button